import { render, staticRenderFns } from "./Calendar2.vue?vue&type=template&id=58d8c1ee&"
import script from "./Calendar2.vue?vue&type=script&lang=js&"
export * from "./Calendar2.vue?vue&type=script&lang=js&"
import style0 from "./Calendar2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports